// Create types
export const INVOICEPAYMENTTYPE_CREATE_ERROR = 'INVOICEPAYMENTTYPE_CREATE_ERROR';
export const INVOICEPAYMENTTYPE_CREATE_LOADING = 'INVOICEPAYMENTTYPE_CREATE_LOADING';
export const INVOICEPAYMENTTYPE_CREATE_SUCCESS = 'INVOICEPAYMENTTYPE_CREATE_SUCCESS';
export const INVOICEPAYMENTTYPE_CREATE_VIOLATIONS = 'INVOICEPAYMENTTYPE_CREATE_VIOLATIONS';
export const INVOICEPAYMENTTYPE_CREATE_RESET = 'INVOICEPAYMENTTYPE_CREATE_RESET';

// Show types
export const INVOICEPAYMENTTYPE_SHOW_ERROR = 'INVOICEPAYMENTTYPE_SHOW_ERROR';
export const INVOICEPAYMENTTYPE_SHOW_LOADING = 'INVOICEPAYMENTTYPE_SHOW_LOADING';
export const INVOICEPAYMENTTYPE_SHOW_RETRIEVED_SUCCESS = 'INVOICEPAYMENTTYPE_SHOW_RETRIEVED_SUCCESS';
export const INVOICEPAYMENTTYPE_SHOW_RESET = 'INVOICEPAYMENTTYPE_SHOW_RESET';

// Update types
export const INVOICEPAYMENTTYPE_UPDATE_RESET = 'INVOICEPAYMENTTYPE_UPDATE_RESET';
export const INVOICEPAYMENTTYPE_UPDATE_UPDATE_ERROR = 'INVOICEPAYMENTTYPE_UPDATE_UPDATE_ERROR';
export const INVOICEPAYMENTTYPE_UPDATE_UPDATE_LOADING = 'INVOICEPAYMENTTYPE_UPDATE_UPDATE_LOADING';
export const INVOICEPAYMENTTYPE_UPDATE_UPDATE_SUCCESS = 'INVOICEPAYMENTTYPE_UPDATE_UPDATE_SUCCESS';
export const INVOICEPAYMENTTYPE_UPDATE_RETRIEVE_ERROR = 'INVOICEPAYMENTTYPE_UPDATE_RETRIEVE_ERROR';
export const INVOICEPAYMENTTYPE_UPDATE_RETRIEVE_LOADING = 'INVOICEPAYMENTTYPE_UPDATE_RETRIEVE_LOADING';
export const INVOICEPAYMENTTYPE_UPDATE_RETRIEVE_SUCCESS = 'INVOICEPAYMENTTYPE_UPDATE_RETRIEVE_SUCCESS';
export const INVOICEPAYMENTTYPE_UPDATE_UPDATE_VIOLATIONS = 'INVOICEPAYMENTTYPE_UPDATE_UPDATE_VIOLATIONS';

// List types
export const INVOICEPAYMENTTYPE_LIST_ERROR = 'INVOICEPAYMENTTYPE_LIST_ERROR';
export const INVOICEPAYMENTTYPE_LIST_LOADING = 'INVOICEPAYMENTTYPE_LIST_LOADING';
export const INVOICEPAYMENTTYPE_LIST_RESET = 'INVOICEPAYMENTTYPE_LIST_RESET';
export const INVOICEPAYMENTTYPE_LIST_VIEW = 'INVOICEPAYMENTTYPE_LIST_VIEW';
export const INVOICEPAYMENTTYPE_LIST_SUCCESS = 'INVOICEPAYMENTTYPE_LIST_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/modules/invoicepaymenttype/mutation-types.js